"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7357],{

/***/ 14900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accessibility_statement_link_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./static/svg/accessibility/accessibility_icon6.svg
var _path, _circle, _circle2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgAccessibilityIcon6 = function SvgAccessibilityIcon6(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        fill: "none",
        viewBox: "0 0 21 21"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.2,
        d: "m6 8 4.035.913v3.155L8.142 17M15.216 8l-4.035.913v3.155L13.074 17"
    })), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 10.5,
        cy: 10.5,
        r: 9.5,
        stroke: "#000",
        strokeLinecap: "round"
    })), _circle2 || (_circle2 = /*#__PURE__*/ react.createElement("circle", {
        cx: 10.5,
        cy: 5.5,
        r: 1.5,
        stroke: "#000"
    })));
};
/* harmony default export */ var accessibility_icon6 = (SvgAccessibilityIcon6);

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/accessibility/accessibility-statement-link/accessibility-statement-link-component.scss.js


var StyledAccessibilityStatementLinkComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e97kqcm0"
})("display:flex;font-size:0.75rem;cursor:pointer;.accessibility-icon-wrapper{display:flex;.accessibility-icon{circle,path{color:", colors/* default.text-gray */.Z["text-gray"], ";transition:stroke 150ms ease;}}}.accessibility-link-wrapper{padding-left:8px;display:flex;align-items:center;.accessibility-link{transition:150ms color ease;color:", colors/* default.text-gray */.Z["text-gray"], ";}}&:hover{.accessibility-icon-wrapper{.accessibility-icon{path,circle{stroke:", colors/* default.iris */.Z.iris, ";}}}.accessibility-link-wrapper{.accessibility-link{color:", colors/* default.iris */.Z.iris, ";}}}");

;// CONCATENATED MODULE: ./components/accessibility/accessibility-statement-link/accessibility-statement-link-component.js





var AccessibilityStatementLinkComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAccessibilityStatementLinkComponent, {
        className: "accessibilty-statement-link-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "accessibility-icon-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accessibility_icon6, {
                    className: "accessibility-icon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "accessibility-link-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: links/* ACCESSIBILITY_STATEMENT_LINK */.eY0,
                    className: "accessibility-link",
                    children: props.translate("footer.accessibiltyStatement")
                })
            })
        ]
    });
};
/* harmony default export */ var accessibility_statement_link_component = ((0,generic_config_context/* withGenericConfig */.P)(AccessibilityStatementLinkComponent));


/***/ }),

/***/ 56914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ short_footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./components/core/language-picker/language-picker-component.js + 6 modules
var language_picker_component = __webpack_require__(39160);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/palette-icons-component.js + 3 modules
var palette_icons_component = __webpack_require__(87917);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/language-picker/language-picker-service.js
var language_picker_service = __webpack_require__(42803);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./constants/work-managment-logos.js
var work_managment_logos = __webpack_require__(74329);
;// CONCATENATED MODULE: ./constants/ai-icons.js
var AI_COLORED_STAR_ICON = "https://dapulse-res.cloudinary.com/image/upload/Subtract.svg";

;// CONCATENATED MODULE: ./components/core/short-footer/short-footer-service.js




var TITLE_TYPE = {
    MAIN: "MAIN",
    MAIN_CLICKABLE: "MAIN_CLICKABLE",
    SECONDARY: "SECONDARY",
    LINK: "LINK"
};
var PRODUCTS_LINKS = [
    {
        title: "header.products",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "header.tabs.solutions.byProduct.workManagement",
        url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
        icon: work_managment_logos/* default.WM_FOOTER_LOGO */.Z.WM_FOOTER_LOGO,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.products.mondaySalesCRM.newLayout.topic",
        url: links/* CRM_MINI_SITE_LINK */.mgz,
        icon: "https://dapulse-res.cloudinary.com/image/upload/CRM_Symbol.svg",
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.products.mondayDev.newLayout.topic",
        url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
        icon: "https://dapulse-res.cloudinary.com/image/upload/DEV_Symbol.svg",
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.products.mondayService.newLayout.topic",
        url: links/* SERVICE_MINI_SITE_LINK */.Kon,
        icon: "https://dapulse-res.cloudinary.com/image/upload/SVC_Symbol.svg",
        type: TITLE_TYPE.LINK
    }
];
var FEATURES_LINKS = [
    {
        title: "footer.features",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.ai",
        url: links/* AI_PAGE_LINK */.lro,
        type: TITLE_TYPE.LINK,
        rightSideIcon: AI_COLORED_STAR_ICON
    },
    {
        title: "footer.dashboard",
        url: links/* DASHBOARDS_PAGE_LINK */.yCu,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.integrations",
        url: links/* INTEGRATIONS_PAGE_LINK */.oUX,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.automations",
        url: links/* AUTOMATIONS_PAGE_LINK */.cPO,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.product.gantt.title",
        url: links/* GANTT_PAGE_LINK */.TA3,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.kanban",
        url: links/* KANBAN_PAGE_LINK */.ivN,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.workdocs",
        url: links/* WORKDOCS_PAGE_LINK */.RdE,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.features.keyFeatures.forms.title",
        url: links/* FORMS_PAGE_LINK */.ua2,
        type: TITLE_TYPE.LINK
    }
];
var COMPANY_LINKS = [
    {
        title: "footer.ourTeam",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.aboutUs",
        url: links/* ABOUT_US_PAGE_LINK */.iAZ,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.careers",
        url: links/* CAREERS_PAGE_LINK */.sb2,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.investorRelations",
        url: links/* INVESTOR_RELATIONS_LINK */.ObI,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.partners",
        url: links/* PARTNERS_PAGE_LINK */.MW2,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.insightsForLeaders",
        url: links/* MONDAY_INSIGHTS_LINK */.Wjj,
        type: TITLE_TYPE.LINK
    }
];
var RESOURCES_LINKS = [
    {
        title: "footer.resources",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.blog",
        url: links/* BLOG_PAGE_LINK */.xR0,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.whatsNew",
        url: links/* WHATS_NEW_PAGE_LINK */.Lmq,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.mondaySpaces",
        url: links/* MONDAY_SPACES_PAGE_LINK */.UN3,
        type: TITLE_TYPE.LINK
    }
];
var TEAM_TYPE_LINKS = [
    {
        title: "footer.projectManagement",
        url: links/* WORK_MANAGEMENT_FOR_PMO_MINI_SITE_LINK */.Y42,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.marketing",
        url: links/* WORK_MANAGEMENT_FOR_MARKETING_MINI_SITE_LINK */.qAD,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.salesUseCase",
        url: links/* CRM_MINI_SITE_LINK */.mgz,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.solutions.byTeam.developers.title",
        url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.operations",
        url: links/* OPERATIONS_CLUSTER_LINK */.R9t,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.itOperations",
        url: links/* SERVICE_MINI_SITE_LINK */.Kon,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.hr",
        url: links/* HR_USE_CASES_LINK */.n$n,
        type: TITLE_TYPE.LINK
    }
];
var COMPANY_SIZE_LINKS = [
    {
        title: "header.tabs.solutions.byTeam.companySize",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.enterprise",
        url: links/* ENTERPRISE_PAGE_LINK */.RVF,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.workflows.byBusinessSize.smallBusiness",
        url: links/* SMB_PAGE_LINK */.qDl,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.workflows.byBusinessSize.nonprofit",
        url: links/* NGO_PAGE_LINK */.htU,
        type: TITLE_TYPE.LINK
    }
];
var TEAMS_LINKS = [
    {
        title: "header.teams",
        type: TITLE_TYPE.MAIN
    }
].concat((0,_to_consumable_array/* default */.Z)(TEAM_TYPE_LINKS), (0,_to_consumable_array/* default */.Z)(COMPANY_SIZE_LINKS));
var LINKS_DATA_COLUMNS = (0,_to_consumable_array/* default */.Z)(PRODUCTS_LINKS).concat((0,_to_consumable_array/* default */.Z)(FEATURES_LINKS), (0,_to_consumable_array/* default */.Z)(COMPANY_LINKS), (0,_to_consumable_array/* default */.Z)(RESOURCES_LINKS), (0,_to_consumable_array/* default */.Z)(TEAMS_LINKS), [
    {
        title: "footer.pricing",
        url: links/* PRICING_PAGE_LINK */.C9V,
        type: TITLE_TYPE.MAIN_CLICKABLE
    },
    {
        title: "footer.contactSales",
        isClickable: true,
        url: links/* CONTACT_SALES_FROM_FOOTER_PAGE_LINK */.vMu,
        type: TITLE_TYPE.MAIN_CLICKABLE
    },
    {
        title: "footer.contactUs",
        isClickable: true,
        url: links/* CONTACT_US_PAGE_LINK */.nO,
        type: TITLE_TYPE.MAIN_CLICKABLE
    }
]);

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./components/core/short-footer/short-footer-link/short-footer-link.scss.js



var StyledShortFooterLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "ekk5iqg0"
})("text-decoration:none;cursor:default;width:fit-content;color:", colors/* default.black */.Z.black, ";line-height:12px;display:flex;align-items:center;gap:4px;transition:100ms color ease;.link-icon{height:12px;width:12px;}&.main-title{font-weight:600;font-size:0.875rem;&.clickable{text-decoration:underline;cursor:pointer;}}&.secondary-title{font-weight:600;color:", colors/* default.asphalt */.Z.asphalt, ";font-size:0.75rem;}&.link{font-weight:400;font-size:0.75rem;cursor:pointer;&:hover{color:", colors/* default */.Z[color_consts.IRIS_COLOR_NAME], ";}}.beta-tag{font-size:0.6875rem;font-weight:400;color:", colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_BACKGROUND_PINK], ";border-radius:12px;padding:1px 5px;line-height:normal;border-radius:32px;}");

;// CONCATENATED MODULE: ./components/core/short-footer/short-footer-link/short-footer-link.js












var _obj;
var LINK_TYPE_TO_CLASS_NAME = (_obj = {}, (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.MAIN, "main-title"), (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.MAIN_CLICKABLE, "main-title clickable"), (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.SECONDARY, "secondary-title"), (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.LINK, "link"), _obj);
var ShortFooterLink = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ShortFooterLink, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ShortFooterLink);
    function ShortFooterLink(props) {
        (0,_class_call_check/* default */.Z)(this, ShortFooterLink);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(ShortFooterLink, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, url = _props.url, translate = _props.translate, type = _props.type, icon = _props.icon, rightSideIcon = _props.rightSideIcon, hasBetaTag = _props.hasBetaTag;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShortFooterLink, {
                    className: classnames_default()("short-footer-link-component", LINK_TYPE_TO_CLASS_NAME[type]),
                    href: url,
                    children: [
                        icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            className: "link-icon",
                            src: icon,
                            alt: translate(title)
                        }),
                        translate(title),
                        rightSideIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            className: "link-icon",
                            src: rightSideIcon,
                            alt: translate(title)
                        }),
                        hasBetaTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "beta-tag",
                            children: translate("header.tabs.solutions.byProduct.dev.beta")
                        })
                    ]
                });
            }
        }
    ]);
    return ShortFooterLink;
}(react.PureComponent);
/* harmony default export */ var short_footer_link = ((0,generic_config_context/* withGenericConfig */.P)(ShortFooterLink));

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/short-footer/short-footer.scss.js



var StyledShortFooter = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("footer", {
    target: "e1n3z9yf0"
})("color:", colors/* default.black */.Z.black, ";display:flex;flex-direction:column;align-items:center;padding:48px 80px;justify-content:center;.short-footer-header{width:100%;justify-content:space-between;display:flex;margin-bottom:48px;flex-direction:row;.language-picker-wrapper-component{width:120px;.language-picker-component{.language-picker-dialog-component-wrapper{margin:0;}}}}.short-footer-links{width:100%;column-count:4;flex-wrap:wrap;.link-wrapper{flex-basis:100%;break-inside:avoid;margin:0 0 20px;&.main:not(:first-child){margin-top:28px;}&.main:nth-child(15n),&.main:nth-child(25n),&.main:nth-child(33n),&.main:nth-child(36n){break-before:column;margin-top:0;}}}.bottom{display:flex;flex-direction:column;margin-top:32px;align-items:center;gap:12px;.terms{display:flex;gap:12px;.accessibility-statement-link-wrapper{display:flex;align-items:center;}}.footer-link{display:flex;align-items:center;text-decoration:underline;a{transition:150ms color ease;color:", colors/* default.text-gray */.Z["text-gray"], ";font-size:0.75rem;}}}.monday-logo-wrapper{.footer-monday-logo-image{height:32px;}}.contact-info-wrapper{font-size:0.8125rem;text-align:center;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){align-items:initial;padding:32px;.short-footer-links{column-count:2;flex-wrap:wrap;.link-wrapper{&.main:nth-child(21n),&.main:nth-child(36n){break-before:column;margin-top:0;}}.link-wrapper{&.main:nth-child(15n),&.main:nth-child(25n),&.main:nth-child(33n){break-before:auto;margin-top:28px;}}}.bottom{align-items:initial;.contact-info-wrapper{text-align:left;width:100%;line-height:24px;.address-info{margin-top:0;}}.social-proof-wrapper{width:100%;.palette-icons-container{margin-top:0;}.icons-wrapper{margin:0 !important;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, "){.terms{flex-wrap:wrap;.accessibility-statement-link-wrapper{flex-basis:100%;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, ") and (min-width:", vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, "){align-items:center;.short-footer-links{column-count:3;flex-wrap:wrap;.link-wrapper{&.main:nth-child(21n){break-before:auto;margin-top:28px;}&.main:nth-child(15n),&.main:nth-child(33n){break-before:column;margin-top:0;}}}.bottom{width:100%;align-items:center;justify-content:center;.contact-info-wrapper{text-align:center;}.social-proof-wrapper{display:flex;align-items:center;justify-content:center;.icons-wrapper{width:fit-content;}}}}}");

// EXTERNAL MODULE: ./components/accessibility/accessibility-statement-link/accessibility-statement-link-component.js + 2 modules
var accessibility_statement_link_component = __webpack_require__(14900);
// EXTERNAL MODULE: ./constants/localization.js
var localization = __webpack_require__(72632);
;// CONCATENATED MODULE: ./components/core/short-footer/short-footer.js





function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}















var short_footer_obj;
var TITLE_TYPE_TO_CLASS_NAME = (short_footer_obj = {}, (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.MAIN, "main"), (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.MAIN_CLICKABLE, "main standalone"), (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.SECONDARY, "secondary"), (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.LINK, "item"), short_footer_obj);
var ShortFooter = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ShortFooter, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ShortFooter);
    function ShortFooter(props) {
        (0,_class_call_check/* default */.Z)(this, ShortFooter);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(ShortFooter, [
        {
            key: "renderLinks",
            value: function renderLinks() {
                var _props = this.props, localeId = _props.localeId, pageClusterConfig = _props.pageClusterConfig, useProductMiniSiteConfig = _props.useProductMiniSiteConfig;
                var links = LINKS_DATA_COLUMNS;
                if (pageClusterConfig) {
                    (0,cluster_config_service/* updateClusterShortFooterLinks */.j8)(pageClusterConfig, links, {
                        useProductMiniSiteConfig: useProductMiniSiteConfig
                    });
                }
                return links.map(function(link) {
                    var title = link.title, type = link.type;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("short-footer-link-component-wrapper", "link-wrapper", (0,_define_property/* default */.Z)({}, TITLE_TYPE_TO_CLASS_NAME[type], type)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer_link, _object_spread({
                            localeId: localeId
                        }, link))
                    }, title);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, translate = _props.translate, localeId = _props.localeId;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShortFooter, {
                    className: "short-footer-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "short-footer-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "monday-logo-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                                        src: links/* MONDAY_LOGO_SRC */.Onk,
                                        className: "footer-monday-logo-image",
                                        href: links/* ROOT_LINK */.yjY,
                                        alt: "monday logo"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "language-picker-wrapper-component link-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(language_picker_component/* default */.Z, {
                                        dialogDirection: language_picker_service/* DIALOG_DIRECTIONS.ALIGN_BOTTOM */.Df.ALIGN_BOTTOM
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "short-footer-links",
                            children: this.renderLinks()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bottom",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "contact-info-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "all-right-reserved-info",
                                        children: [
                                            translate("allRightsReserved"),
                                            " \xa9 monday.com"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "social-proof-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(palette_icons_component/* default */.Z, {
                                        SocialFooterLinks: links/* SocialFooterLinks */.Ff7
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "terms",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "accessibility-statement-link-wrapper link-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accessibility_statement_link_component/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: links/* LEGAL_PORTAL_LINK */.CYg,
                                                children: translate("footer.legal")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: links/* PRIVACY_POLICY_LINK */.jbE,
                                                children: translate("footer.privacyPolicy")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                "data-footer-link-type": "cookie-settings",
                                                onClick: function() {
                                                    var _window_cookiehub, _window;
                                                    return (_window = window) === null || _window === void 0 ? void 0 : (_window_cookiehub = _window.cookiehub) === null || _window_cookiehub === void 0 ? void 0 : _window_cookiehub.openSettings();
                                                },
                                                children: translate("footer.yourPrivacyChoices")
                                            })
                                        }),
                                        localeId === localization.GERMAN_LOCALE_ID && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: links/* IMPRESSUM_LINK */.YSM,
                                                children: translate("footer.impressum")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return ShortFooter;
}(react.PureComponent);
/* harmony default export */ var short_footer = ((0,generic_config_context/* withGenericConfig */.P)(ShortFooter));


/***/ }),

/***/ 46374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ footer_bottom_bar_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/language-picker/language-picker-component.js + 6 modules
var language_picker_component = __webpack_require__(39160);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./components/core/language-picker/language-picker-service.js
var language_picker_service = __webpack_require__(42803);
// EXTERNAL MODULE: ./components/accessibility/accessibility-statement-link/accessibility-statement-link-component.js + 2 modules
var accessibility_statement_link_component = __webpack_require__(14900);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./static/svg/social/google_play_big.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgGooglePlayBig = function SvgGooglePlayBig(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 135,
        height: 40,
        fill: "none",
        viewBox: "0 0 135 40"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        d: "M130 40H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5h125c2.8 0 5 2.2 5 5v30c0 2.7-2.2 5-5 5"
    })), _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#A6A6A6",
        d: "M130 .8c2.3 0 4.2 1.9 4.2 4.2v30c0 2.3-1.9 4.2-4.2 4.2H5C2.7 39.2.8 37.3.8 35V5C.8 2.7 2.7.8 5 .8zm0-.8H5C2.2 0 0 2.2 0 5v30c0 2.8 2.2 5 5 5h125c2.8 0 5-2.2 5-5V5c0-2.7-2.2-5-5-5"
    })), _path3 || (_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        stroke: "#fff",
        strokeMiterlimit: 10,
        strokeWidth: 0.2,
        d: "M47.4 10.2c0 .8-.2 1.5-.7 2-.6.6-1.3.9-2.2.9s-1.6-.3-2.2-.9-.9-1.3-.9-2.2.3-1.6.9-2.2 1.3-.9 2.2-.9q.6 0 1.2.3c.4.2.7.4.9.7l-.5.5c-.4-.5-.9-.7-1.6-.7-.6 0-1.2.2-1.6.7-.5.4-.7 1-.7 1.7s.2 1.3.7 1.7 1 .7 1.6.7c.7 0 1.2-.2 1.7-.7.3-.3.5-.7.5-1.2h-2.2v-.7h2.9zM52 7.7h-2.7v1.9h2.5v.7h-2.5v1.9H52v.8h-3.5V7H52zM55.3 13h-.8V7.7h-1.7V7H57v.7h-1.7zM59.9 13V7h.8v6zM64.1 13h-.8V7.7h-1.7V7h4.1v.7H64V13zM73.6 12.2c-.6.6-1.3.9-2.2.9s-1.6-.3-2.2-.9-.9-1.3-.9-2.2.3-1.6.9-2.2 1.3-.9 2.2-.9 1.6.3 2.2.9.9 1.3.9 2.2-.3 1.6-.9 2.2Zm-3.8-.5c.4.4 1 .7 1.6.7s1.2-.2 1.6-.7c.4-.4.7-1 .7-1.7s-.2-1.3-.7-1.7c-.4-.4-1-.7-1.6-.7s-1.2.2-1.6.7c-.4.4-.7 1-.7 1.7s.2 1.3.7 1.7ZM75.6 13V7h.9l2.9 4.7V7h.8v6h-.8l-3.1-4.9V13z"
    })), _path4 || (_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M68.1 21.8c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3m0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6 2.4 1 2.4 2.6c0 1.5-1.1 2.6-2.4 2.6m-9.3-6.8c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3m0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6 2.4 1 2.4 2.6c0 1.5-1.1 2.6-2.4 2.6m-11.1-5.5v1.8H52c-.1 1-.5 1.8-1 2.3-.6.6-1.6 1.3-3.3 1.3-2.7 0-4.7-2.1-4.7-4.8s2.1-4.8 4.7-4.8c1.4 0 2.5.6 3.3 1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8-3.6 0-6.7 3-6.7 6.6s3.1 6.6 6.7 6.6c2 0 3.4-.6 4.6-1.9 1.2-1.2 1.6-2.9 1.6-4.2 0-.4 0-.8-.1-1.1zm45.4 1.4c-.4-1-1.4-2.7-3.6-2.7s-4 1.7-4 4.3c0 2.4 1.8 4.3 4.2 4.3 1.9 0 3.1-1.2 3.5-1.9l-1.4-1c-.5.7-1.1 1.2-2.1 1.2s-1.6-.4-2.1-1.3l5.7-2.4zm-5.8 1.4c0-1.6 1.3-2.5 2.2-2.5.7 0 1.4.4 1.6.9zM82.6 30h1.9V17.5h-1.9zm-3-7.3c-.5-.5-1.3-1-2.3-1-2.1 0-4.1 1.9-4.1 4.3s1.9 4.2 4.1 4.2c1 0 1.8-.5 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1.1 0-1.9-.8-2.1-1.5l-1.6.7c.5 1.1 1.7 2.5 3.8 2.5 2.2 0 4-1.3 4-4.4V22h-1.8zm-2.2 5.9c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6 2.3 1.1 2.3 2.6-1 2.6-2.3 2.6m24.4-11.1h-4.5V30h1.9v-4.7h2.6c2.1 0 4.1-1.5 4.1-3.9s-2-3.9-4.1-3.9m.1 6h-2.7v-4.3h2.7c1.4 0 2.2 1.2 2.2 2.1-.1 1.1-.9 2.2-2.2 2.2m11.5-1.8c-1.4 0-2.8.6-3.3 1.9l1.7.7c.4-.7 1-.9 1.7-.9 1 0 1.9.6 2 1.6v.1c-.3-.2-1.1-.5-1.9-.5-1.8 0-3.6 1-3.6 2.8 0 1.7 1.5 2.8 3.1 2.8 1.3 0 1.9-.6 2.4-1.2h.1v1h1.8v-4.8c-.2-2.2-1.9-3.5-4-3.5m-.2 6.9c-.6 0-1.5-.3-1.5-1.1 0-1 1.1-1.3 2-1.3.8 0 1.2.2 1.7.4-.2 1.2-1.2 2-2.2 2m10.5-6.6-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h1.9l5.1-11.8zm-16.8 8h1.9V17.5h-1.9z"
    })), _path5 || (_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear)",
        d: "M10.4 7.5c-.3.3-.5.8-.5 1.4V31c0 .6.2 1.1.5 1.4l.1.1 12.4-12.4v-.2z"
    })), _path6 || (_path6 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear)",
        d: "m27 24.3-4.1-4.1v-.3l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9z"
    })), _path7 || (_path7 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint2_linear)",
        d: "M27.1 24.2 22.9 20 10.4 32.5c.5.5 1.2.5 2.1.1z"
    })), _path8 || (_path8 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint3_linear)",
        d: "M27.1 15.8 12.5 7.5c-.9-.5-1.6-.4-2.1.1L22.9 20z"
    })), _path9 || (_path9 = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        d: "m27 24.1-14.5 8.2c-.8.5-1.5.4-2 0l-.1.1.1.1c.5.4 1.2.5 2 0z",
        opacity: 0.2
    })), _path10 || (_path10 = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        d: "M10.4 32.3c-.3-.3-.4-.8-.4-1.4v.1c0 .6.2 1.1.5 1.4v-.1zM32 21.3l-5 2.8.1.1 4.9-2.8c.7-.4 1-.9 1-1.4 0 .5-.4.9-1 1.3",
        opacity: 0.12
    })), _path11 || (_path11 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M12.5 7.6 32 18.7c.6.4 1 .8 1 1.3 0-.5-.3-1-1-1.4L12.5 7.5C11.1 6.7 10 7.4 10 9v.1c0-1.6 1.1-2.3 2.5-1.5",
        opacity: 0.25
    })), _defs || (_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear",
        x1: 21.8,
        x2: 5.017,
        y1: 8.71,
        y2: 25.492,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#00A0FF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.007,
        stopColor: "#00A1FF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.26,
        stopColor: "#00BEFF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.512,
        stopColor: "#00D2FF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.76,
        stopColor: "#00DFFF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#00E3FF"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear",
        x1: 33.834,
        x2: 9.637,
        y1: 20.001,
        y2: 20.001,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FFE000"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.409,
        stopColor: "#FFBD00"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.775,
        stopColor: "orange"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FF9C00"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint2_linear",
        x1: 24.827,
        x2: 2.069,
        y1: 22.296,
        y2: 45.054,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FF3A44"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#C31162"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint3_linear",
        x1: 7.297,
        x2: 17.46,
        y1: 0.176,
        y2: 10.339,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#32A071"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.069,
        stopColor: "#2DA771"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.476,
        stopColor: "#15CF74"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.801,
        stopColor: "#06E775"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#00F076"
    })))));
};
/* harmony default export */ var google_play_big = (SvgGooglePlayBig);

;// CONCATENATED MODULE: ./static/svg/social/app_store_big.svg
var app_store_big_path, app_store_big_path2, app_store_big_path3;
function app_store_big_extends() {
    app_store_big_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return app_store_big_extends.apply(this, arguments);
}

var SvgAppStoreBig = function SvgAppStoreBig(props) {
    return /*#__PURE__*/ react.createElement("svg", app_store_big_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 120,
        height: 40,
        fill: "none",
        viewBox: "0 0 120 40"
    }, props), app_store_big_path || (app_store_big_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#A6A6A6",
        d: "M110.135 0H9.535Q8.986 0 8.44.002q-.457.004-.919.013Q6.513.027 5.517.19a6.7 6.7 0 0 0-1.9.627A6.44 6.44 0 0 0 .193 5.521a13 13 0 0 0-.179 2.002c-.01.307-.01.615-.015.921V31.56c.005.31.006.61.015.921q.012 1.008.18 2.002c.11.663.32 1.306.624 1.905.303.598.701 1.143 1.179 1.614.473.477 1.019.875 1.618 1.179s1.24.517 1.901.63q.996.164 2.004.177c.31.007.613.011.919.011.366.002.728.002 1.095.002h100.6c.359 0 .724 0 1.084-.002.304 0 .617-.004.922-.01q1.006-.014 2-.178a6.8 6.8 0 0 0 1.908-.63A6.3 6.3 0 0 0 117.666 38a6.4 6.4 0 0 0 1.182-1.614c.302-.6.51-1.242.619-1.905q.167-.993.185-2.001c.004-.311.004-.612.004-.922.008-.364.008-.725.008-1.094V9.536q.002-.549-.008-1.092.001-.46-.004-.92a13.6 13.6 0 0 0-.185-2.003 6.7 6.7 0 0 0-.619-1.903 6.47 6.47 0 0 0-2.799-2.8 6.8 6.8 0 0 0-1.908-.627q-.993-.165-2-.176c-.305-.005-.618-.011-.922-.013-.36-.002-.725-.002-1.084-.002"
    })), app_store_big_path2 || (app_store_big_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        d: "M8.445 39.125c-.305 0-.602-.004-.904-.01a13 13 0 0 1-1.87-.164 5.9 5.9 0 0 1-1.656-.548 5.4 5.4 0 0 1-1.397-1.016 5.3 5.3 0 0 1-1.02-1.397 5.7 5.7 0 0 1-.544-1.657 12.4 12.4 0 0 1-.166-1.875c-.007-.21-.015-.913-.015-.913v-23.1s.009-.692.015-.895a12.4 12.4 0 0 1 .165-1.872 5.8 5.8 0 0 1 .544-1.662c.26-.518.603-.99 1.015-1.398A5.57 5.57 0 0 1 5.667 1.05C6.287.95 6.915.895 7.543.887l.902-.012h102.769l.913.013a12.4 12.4 0 0 1 1.858.162 6 6 0 0 1 1.671.548 5.6 5.6 0 0 1 2.415 2.42 5.7 5.7 0 0 1 .535 1.649q.156.937.174 1.887c.003.283.003.588.003.89.008.375.008.732.008 1.092v20.929c0 .363 0 .718-.008 1.075 0 .325 0 .623-.004.93q-.017.932-.171 1.853a5.7 5.7 0 0 1-.54 1.67 5.5 5.5 0 0 1-1.015 1.386 5.4 5.4 0 0 1-1.4 1.022 5.9 5.9 0 0 1-1.668.55q-.928.152-1.869.163c-.293.007-.599.011-.897.011l-1.084.002z"
    })), app_store_big_path3 || (app_store_big_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M24.769 20.3a4.95 4.95 0 0 1 2.356-4.151 5.07 5.07 0 0 0-3.99-2.158c-1.68-.176-3.308 1.005-4.164 1.005-.872 0-2.19-.988-3.608-.958a5.32 5.32 0 0 0-4.473 2.727c-1.934 3.349-.492 8.27 1.361 10.977.927 1.325 2.01 2.805 3.428 2.753 1.387-.058 1.905-.885 3.58-.885 1.658 0 2.144.885 3.59.852 1.489-.025 2.426-1.332 3.32-2.67a11 11 0 0 0 1.52-3.092 4.78 4.78 0 0 1-2.92-4.4M22.037 12.21a4.87 4.87 0 0 0 1.115-3.49 4.96 4.96 0 0 0-3.208 1.66 4.64 4.64 0 0 0-1.143 3.361 4.1 4.1 0 0 0 3.236-1.53M42.302 27.14H37.57l-1.137 3.356h-2.005l4.484-12.418h2.083l4.483 12.418h-2.039zm-4.243-1.55h3.752l-1.85-5.446h-.051zM55.16 25.97c0 2.813-1.506 4.62-3.779 4.62a3.07 3.07 0 0 1-2.848-1.583h-.043v4.484H46.63V21.442h1.8v1.506h.033a3.21 3.21 0 0 1 2.883-1.6c2.298 0 3.813 1.816 3.813 4.622m-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.392-1.197 2.392-3.046M65.125 25.97c0 2.813-1.506 4.62-3.779 4.62a3.07 3.07 0 0 1-2.848-1.583h-.043v4.484h-1.859V21.442h1.799v1.506h.034a3.21 3.21 0 0 1 2.883-1.6c2.298 0 3.813 1.816 3.813 4.622m-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.392-1.197 2.392-3.046M71.71 27.036c.138 1.232 1.335 2.04 2.97 2.04 1.566 0 2.693-.809 2.693-1.919 0-.964-.68-1.54-2.29-1.936l-1.609-.388c-2.28-.55-3.339-1.617-3.339-3.348 0-2.142 1.867-3.614 4.519-3.614 2.624 0 4.423 1.472 4.483 3.614h-1.876c-.112-1.239-1.136-1.987-2.634-1.987s-2.521.757-2.521 1.858c0 .878.654 1.395 2.255 1.79l1.368.336c2.548.603 3.606 1.626 3.606 3.443 0 2.323-1.85 3.778-4.793 3.778-2.754 0-4.614-1.42-4.734-3.667zM83.346 19.3v2.142h1.722v1.472h-1.722v4.991c0 .776.345 1.137 1.102 1.137q.306-.006.611-.043v1.463q-.512.095-1.032.086c-1.833 0-2.548-.689-2.548-2.444v-5.19h-1.316v-1.472h1.316V19.3zM86.065 25.97c0-2.849 1.678-4.639 4.294-4.639 2.625 0 4.295 1.79 4.295 4.639 0 2.856-1.661 4.638-4.295 4.638s-4.294-1.782-4.294-4.638m6.695 0c0-1.954-.895-3.108-2.401-3.108s-2.4 1.162-2.4 3.108c0 1.962.894 3.106 2.4 3.106s2.401-1.144 2.401-3.106M96.186 21.442h1.772v1.541h.043a2.16 2.16 0 0 1 2.178-1.635q.322-.002.637.069v1.738a2.6 2.6 0 0 0-.835-.112 1.872 1.872 0 0 0-1.937 2.083v5.37h-1.858zM109.384 27.837c-.25 1.643-1.85 2.771-3.898 2.771-2.634 0-4.269-1.764-4.269-4.595 0-2.84 1.644-4.682 4.191-4.682 2.505 0 4.08 1.72 4.08 4.466v.637h-6.395v.112a2.35 2.35 0 0 0 .639 1.832 2.36 2.36 0 0 0 1.797.732 2.045 2.045 0 0 0 2.091-1.273zm-6.282-2.702h4.526a2.17 2.17 0 0 0-.608-1.634 2.17 2.17 0 0 0-1.612-.664 2.29 2.29 0 0 0-2.306 2.298M37.826 8.731a2.64 2.64 0 0 1 2.808 2.965c0 1.906-1.03 3.002-2.808 3.002h-2.155V8.73zm-1.228 5.123h1.125a1.876 1.876 0 0 0 1.967-2.146 1.882 1.882 0 0 0-1.967-2.134h-1.125zM41.68 12.444a2.132 2.132 0 1 1 4.248 0 2.135 2.135 0 1 1-4.247 0m3.334 0c0-.976-.439-1.546-1.208-1.546-.773 0-1.207.57-1.207 1.546 0 .984.434 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55M51.573 14.698h-.922l-.93-3.317h-.07l-.927 3.317h-.913l-1.242-4.503h.902l.806 3.436h.067l.926-3.436h.852l.926 3.436h.07l.803-3.436h.889zM53.854 10.195h.855v.715h.066a1.35 1.35 0 0 1 1.344-.802 1.464 1.464 0 0 1 1.559 1.675v2.915h-.889v-2.692c0-.724-.314-1.084-.972-1.084a1.03 1.03 0 0 0-1.075 1.141v2.635h-.889zM59.094 8.437h.888v6.26h-.888zM61.218 12.444a2.134 2.134 0 1 1 4.247 0 2.133 2.133 0 1 1-4.247 0m3.333 0c0-.976-.439-1.546-1.208-1.546-.773 0-1.207.57-1.207 1.546 0 .984.434 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55M66.4 13.424c0-.81.604-1.277 1.676-1.344l1.22-.07v-.389c0-.476-.315-.744-.922-.744-.496 0-.84.182-.939.5h-.86c.09-.773.818-1.27 1.84-1.27 1.128 0 1.765.563 1.765 1.514v3.077h-.855v-.633h-.07a1.52 1.52 0 0 1-1.353.707 1.36 1.36 0 0 1-1.501-1.348m2.895-.384v-.377l-1.1.07c-.62.042-.9.253-.9.65 0 .405.351.64.834.64a1.06 1.06 0 0 0 1.166-.983M71.348 12.444c0-1.423.732-2.324 1.87-2.324a1.48 1.48 0 0 1 1.38.79h.067V8.437h.888v6.26h-.851v-.71h-.07a1.56 1.56 0 0 1-1.415.785c-1.145 0-1.869-.901-1.869-2.328m.918 0c0 .955.45 1.53 1.203 1.53.75 0 1.212-.583 1.212-1.526 0-.938-.468-1.53-1.212-1.53-.748 0-1.203.58-1.203 1.526M79.23 12.444a2.132 2.132 0 1 1 4.247 0 2.135 2.135 0 1 1-4.247 0m3.333 0c0-.976-.439-1.546-1.208-1.546-.773 0-1.207.57-1.207 1.546 0 .984.435 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55M84.67 10.195h.855v.715h.066a1.35 1.35 0 0 1 1.344-.802 1.464 1.464 0 0 1 1.559 1.675v2.915h-.889v-2.692c0-.724-.314-1.084-.972-1.084a1.03 1.03 0 0 0-1.075 1.141v2.635h-.889zM93.515 9.074v1.141h.976v.749h-.976v2.315c0 .472.195.678.637.678q.17 0 .339-.02v.74q-.24.043-.484.046c-.988 0-1.382-.348-1.382-1.216v-2.543h-.714v-.749h.715V9.074zM95.705 8.437h.88v2.482h.07a1.385 1.385 0 0 1 1.374-.807 1.482 1.482 0 0 1 1.55 1.678v2.908h-.889V12.01c0-.72-.335-1.084-.963-1.084a1.05 1.05 0 0 0-1.134 1.142v2.63h-.888zM104.761 13.482a1.82 1.82 0 0 1-1.951 1.303 2.045 2.045 0 0 1-2.08-2.325 2.077 2.077 0 0 1 2.076-2.352c1.253 0 2.009.856 2.009 2.27v.31h-3.18v.05a1.19 1.19 0 0 0 1.199 1.29 1.08 1.08 0 0 0 1.072-.546zm-3.126-1.451h2.275a1.09 1.09 0 0 0-1.109-1.167 1.15 1.15 0 0 0-1.166 1.167"
    })));
};
/* harmony default export */ var app_store_big = (SvgAppStoreBig);

// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/palette-icons-component.js + 3 modules
var palette_icons_component = __webpack_require__(87917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.scss.js





var TOP_ROW_HEIGHT = 40;
var BOTTOM_ROW_HEIGHT = 24;
var FOOTER_PADDING = constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING * 2;
var FOOTER_PADDING_STRING = "".concat(FOOTER_PADDING, "px");
var FOOTER_WIDTH = "calc(100% - ".concat(FOOTER_PADDING_STRING, ")");
var StyledFooterBottomBarComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e148pwkx0"
})("position:relative;font-size:0.8125rem;color:", colors/* default.brand-gray */.Z["brand-gray"], ';width:100%;display:flex;flex-direction:column;align-items:center;justify-content:space-between;&:before{display:block;content:"";height:1px;width:', FOOTER_WIDTH, ";background-color:", colors/* default.gainsboro */.Z.gainsboro, ";position:relative;max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld - FOOTER_PADDING, "px;}.footer-contact-sales-section{padding:36px;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";text-align:center;.footer-contact-sales-title{.core-title{font-weight:600;}margin-bottom:8px;}.footer-contact-sales-subtitle{.paragraph-wrapper .paragraph-body{font-size:1rem;}}.footer-contact-sales-button-wrapper{margin-top:32px;display:flex;justify-content:center;.regular-button{.button-component{font-weight:400;}}}}.footer-bottom-bar-both-sides-wrapper{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;margin:0 auto;display:flex;justify-content:space-between;padding:40px 32px 48px;align-items:center;height:180px;}.footer-bottom-bar-left-side{display:flex;flex-direction:row;gap:32px;height:100%;.language-picker-and-security-logos-wrapper{display:flex;flex-direction:column;height:100%;justify-content:space-between;.language-picker-wrapper{height:40px;display:flex;align-items:center;}}.social-statement-and-links-wrapper{display:flex;flex-direction:column;height:100%;justify-content:space-between;.palette-icons-wrapper{height:40px;display:flex;}.statement-and-links-wrapper{height:", BOTTOM_ROW_HEIGHT, 'px;display:flex;align-items:center;padding-bottom:6px;gap:24px;.links-container{display:flex;flex-wrap:wrap;row-gap:4px;max-width:90%;.short-footer-link-component-wrapper{display:flex;align-items:center;&:not(:last-of-type):after{content:" | ";margin:0 8px;}}}.all-rights-reserved-component{padding-bottom:2px;white-space:nowrap;padding-right:20px;}}}}.footer-bottom-bar-right-side{display:flex;flex-direction:column;justify-content:space-between;height:100%;.app-store-icons{display:flex;gap:16px;height:', TOP_ROW_HEIGHT, "px;}.accessibility-statement-link-wrapper{height:", BOTTOM_ROW_HEIGHT, "px;display:flex;align-items:center;padding-bottom:6px;}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, ") and (min-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.items-container{padding:0 54px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/links/footer-bottom-bar-link/footer-bottom-bar-link-component.scss.js


var StyledFooterBottomBarLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1xzg02t0"
})("font-size:0.8125rem;color:", colors/* default.text-gray */.Z["text-gray"], ";transition:100ms color ease;text-decoration:underline;&:hover{color:", colors/* default.iris */.Z.iris, ";}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/links/footer-bottom-bar-link/footer-bottom-bar-link-component.js



var FooterBottomBarLink = function(props) {
    var title = props.title, url = props.url, translate = props.translate, onClick = props.onClick, customAttribute = props.customAttribute;
    var onLinkClick = function(event) {
        return onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterBottomBarLink, {
        className: "footer-bottom-bar-link-component",
        href: url,
        onClick: onLinkClick,
        "data-footer-link-type": customAttribute,
        children: translate(title)
    });
};
/* harmony default export */ var footer_bottom_bar_link_component = ((0,generic_config_context/* withGenericConfig */.P)(FooterBottomBarLink));

;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/links/index.js

var linkComponentTypes = {
    FooterBottomBarLink: footer_bottom_bar_link_component
};
/* harmony default export */ var footer_bottom_bar_links = (linkComponentTypes);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/security-logos/security-logos-component.scss.js

var StyledSecurityLogosComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1w3ivpx0"
})("display:flex;.iso-logo-img-container,.gdpr-logo-img-container,.hipaa-logo-img-container,.soc-logo-img-container{margin-right:8px;cursor:pointer;img{height:32px;}&:hover{img{opacity:0.7;}}}");

// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/security-logos/security-logos-component.js










var ISO_LOGO_SRC = "/static/img/footer/iso-logo1.png";
var GDPR_LOGO_SRC = "/static/img/footer/gdpr-logo.png";
var SOC_LOGO_SRC = "/static/img/footer/soc-logo.png";
var HIPAA_LOGO_SRC = "/static/img/footer/hipaa-logo.png";
var ISO = "iso";
var SOC = "soc";
var GDPR = "gdpr";
var HIPAA = "hipaa";
var SecurityLogosComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SecurityLogosComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SecurityLogosComponent);
    function SecurityLogosComponent() {
        (0,_class_call_check/* default */.Z)(this, SecurityLogosComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SecurityLogosComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSecurityLogosComponent, {
                    className: "security-logos-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "gdpr-logo-img-container",
                            onClick: this.goToGdprPage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                                src: GDPR_LOGO_SRC,
                                alt: "gdpr",
                                href: links/* SecurityLogoLinks */.Rbz[GDPR]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "iso-logo-img-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                                src: ISO_LOGO_SRC,
                                alt: "iso",
                                href: links/* SecurityLogoLinks */.Rbz[ISO]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "soc-logo-img-container",
                            onClick: this.goToSocPage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                                src: SOC_LOGO_SRC,
                                alt: "soc",
                                href: links/* SecurityLogoLinks */.Rbz[SOC]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hipaa-logo-img-container",
                            onClick: this.goToHipaaPage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                                src: HIPAA_LOGO_SRC,
                                alt: "hipaa",
                                href: links/* SecurityLogoLinks */.Rbz[HIPAA]
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return SecurityLogosComponent;
}(react.PureComponent);
/* harmony default export */ var security_logos_component = ((0,generic_config_context/* withGenericConfig */.P)(SecurityLogosComponent));

;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/all-rights-reserved/all-rights-reserved-component.scss.js



var StyledAllRightsReservedComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e80m6a10"
})(".details{font-size:0.8125rem;line-height:2;height:24px;color:", colors/* default.text-gray */.Z["text-gray"], ";}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){display:flex;margin-left:24px;.icons-wrapper{margin-left:48px;}}");

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/all-rights-reserved/all-rights-reserved-component.js









var AllRightsReservedComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AllRightsReservedComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(AllRightsReservedComponent);
    function AllRightsReservedComponent() {
        (0,_class_call_check/* default */.Z)(this, AllRightsReservedComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AllRightsReservedComponent, [
        {
            key: "getText",
            value: function getText() {
                var translate = this.props.translate;
                return translate("allRightsReserved");
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAllRightsReservedComponent, {
                    className: "all-rights-reserved-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "details",
                        children: [
                            this.getText(),
                            " \xa9 monday.com"
                        ]
                    })
                });
            }
        }
    ]);
    return AllRightsReservedComponent;
}(react.PureComponent);
/* harmony default export */ var all_rights_reserved_component = ((0,generic_config_context/* withGenericConfig */.P)((0,router.withRouter)(AllRightsReservedComponent)));

// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js + 1 modules
var regular_button = __webpack_require__(35662);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


























var FooterBottomBarComponent = function(props) {
    var localeId = props.localeId, SocialFooterLinks = props.SocialFooterLinks, footerType = props.footerType, simulateContactSalesButtonInTheFooter = props.simulateContactSalesButtonInTheFooter, abTests = props.abTests, translate = props.translate, hideContactSalesInFooter = props.hideContactSalesInFooter;
    var onVisibilityChange = function(isVisible) {
        if (isVisible) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.FOOTER_BOTTOM_BAR_VIEWD_VIEWD, {
                kind: footerType
            });
        }
    };
    var renderLinks = function() {
        return links/* LONG_FOOTER_BOTTOM_LINKS.map */.aGd.map(function(linkData) {
            var title = linkData.title, componentName = linkData.componentName;
            var ComponentToRender = footer_bottom_bar_links[componentName];
            // if link is locale specific
            if (linkData.localeId && linkData.localeId !== localeId) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("short-footer-link-component-wrapper"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentToRender, _object_spread({
                    localeId: localeId
                }, linkData))
            }, title);
        });
    };
    var renderLanguagePicker = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(language_picker_component/* default */.Z, {
            dialogDirection: language_picker_service/* DIALOG_DIRECTIONS.ALIGN_TOP */.Df.ALIGN_TOP
        });
    };
    var renderAccessibilityStatementLink = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(accessibility_statement_link_component/* default */.Z, {});
    };
    var shouldGetContactSalesButton = !hideContactSalesInFooter && (simulateContactSalesButtonInTheFooter || (0,acquisition_ab_test_service.shouldGetContactSalesInTheFooter)(abTests, true));
    var footerContactSalesClicked = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.FOOTER_CONTACT_SALES_BUTTON_CLICKED);
    };
    var getContactSalesCTA = function() {
        return translate("header.contactSales");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        partialVisibility: true,
        active: true,
        scrollCheck: true,
        onChange: onVisibilityChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterBottomBarComponent, {
            className: "footer-bottom-bar-component",
            children: [
                shouldGetContactSalesButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "footer-contact-sales-section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "footer-contact-sales-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                                title: translate("footer.contactSalesTitle"),
                                titleSize: button_component.SM
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "footer-contact-sales-subtitle",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                                body: translate("footer.contactSalesSubTitle")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "footer-contact-sales-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, {
                                buttonText: getContactSalesCTA(),
                                color: color_consts.WORK_OS_IRIS_COLOR_NAME,
                                outline: true,
                                url: links/* CONTACT_SALES_PAGE_LINK */.yMV,
                                isWithArrow: false,
                                buttonSize: button_component.LG,
                                onClick: footerContactSalesClicked
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "footer-bottom-bar-both-sides-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "footer-bottom-bar-left-side",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "language-picker-and-security-logos-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "language-picker-wrapper",
                                            children: renderLanguagePicker()
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "security-logos-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(security_logos_component, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "social-statement-and-links-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "palette-icons-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(palette_icons_component/* default */.Z, {
                                                SocialFooterLinks: SocialFooterLinks
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "statement-and-links-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "links-container",
                                                children: [
                                                    renderLinks(),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(all_rights_reserved_component, {})
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "footer-bottom-bar-right-side",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "app-store-icons",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            className: "app-icon",
                                            href: links/* ANDROID_APP_DOWNLOAD_LINK */.Je_,
                                            title: "Download the monday android App from Google Play",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(google_play_big, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            className: "app-icon",
                                            href: links/* IOS_APP_DOWNLOAD_LINK */.XYT,
                                            title: "Download the monday iOS App from the App Store",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(app_store_big, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "accessibility-statement-link-wrapper",
                                    children: renderAccessibilityStatementLink()
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_bottom_bar_component = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(FooterBottomBarComponent)));


/***/ }),

/***/ 87917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PaletteIconsComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/palette-icons-component.scss.js


var StyledSinglePaletteIconComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ktd0x80"
})("display:flex;.icons-wrapper{display:flex;justify-content:space-between;align-items:center;gap:16px;}.single-app-icon-wrapper{margin-right:8px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){margin:0 auto;padding:0;flex-wrap:wrap;margin-top:16px;.icons-wrapper:first-child{margin-right:auto;}.icons-wrapper{width:200px;margin:0 auto;margin-bottom:8px;}}");

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/single-palette-icon/single-palette-icon-component.scss.js



var single_palette_icon_component_scss_StyledSinglePaletteIconComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e76zi3x0"
})("svg{height:24px;width:auto;}&:hover{svg{path{fill:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/single-palette-icon/single-palette-icon-component.js







var SinglePaletteIconComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SinglePaletteIconComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SinglePaletteIconComponent);
    function SinglePaletteIconComponent() {
        (0,_class_call_check/* default */.Z)(this, SinglePaletteIconComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SinglePaletteIconComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, clickableLink = _props.clickableLink, IconComp = _props.IconComp, title = _props.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(single_palette_icon_component_scss_StyledSinglePaletteIconComponent, {
                    className: "social-media-icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        href: clickableLink,
                        title: title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "regular-icon-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComp, {})
                        })
                    })
                }, clickableLink);
            }
        }
    ]);
    return SinglePaletteIconComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/palette-icons-component.js








var PaletteIconsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PaletteIconsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PaletteIconsComponent);
    function PaletteIconsComponent() {
        (0,_class_call_check/* default */.Z)(this, PaletteIconsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PaletteIconsComponent, [
        {
            key: "renderSocialMediaIcons",
            value: function renderSocialMediaIcons() {
                var SocialFooterLinks = this.props.SocialFooterLinks;
                var socialMediasIcons = SocialFooterLinks.links;
                return Object.keys(socialMediasIcons).map(function(key) {
                    var socialMediaIcon = socialMediasIcons[key];
                    var IconComp = socialMediaIcon.iconV2;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "single-social-icon-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SinglePaletteIconComponent, {
                            IconComp: IconComp,
                            clickableLink: socialMediaIcon.url,
                            title: socialMediaIcon.title
                        })
                    }, key);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSinglePaletteIconComponent, {
                    className: "palette-icons-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "icons-wrapper",
                        children: this.renderSocialMediaIcons()
                    })
                });
            }
        }
    ]);
    return PaletteIconsComponent;
}(react.PureComponent);



/***/ }),

/***/ 70212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ footer_category_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var constants_links = __webpack_require__(27639);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.scss.js



var StyledFooterCategoryComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eimm8020"
})(".footer-category-image-and-title-warpper{.monday-logo-wrapper{margin-bottom:14px;.footer-monday-logo-image{height:32px;}}.title{margin-top:10px;margin-bottom:24px;font-size:0.875rem;font-weight:500;}}.link{line-height:22px;&:not(:last-child){margin-bottom:16px;}&:hover{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}a{text-decoration:none;color:inherit;display:flex;column-gap:8px;align-items:center;.picture-component{display:flex;img{height:18px;}}}.beta-tag{font-size:0.6875rem;font-weight:400;color:", colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_BACKGROUND_PINK], ";border-radius:12px;padding:1px 5px;line-height:normal;border-radius:32px;}}");

// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js









var FooterCategoryComponent = function(props) {
    var title = props.title, translate = props.translate, links = props.links, type = props.type, hasMondayLogoTitle = props.hasMondayLogoTitle;
    var trackLinkClick = function(event) {
        var target = event.target;
        var href = (0,url.normalizeUrl)(target.href);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.FOOTER_LINK_CLICK, {
            kind: href
        });
    };
    var mapLinkByType = function(param) {
        var linkKey = param.linkKey;
        var link = links[linkKey];
        var href, icon, openInNewTab, hasBetaTag;
        switch(type){
            case constants_links/* ENRICHED_FOOTER_LINKS */.ihQ:
                icon = link === null || link === void 0 ? void 0 : link.icon;
                href = link === null || link === void 0 ? void 0 : link.href;
                openInNewTab = link === null || link === void 0 ? void 0 : link.openInNewTab;
                hasBetaTag = link === null || link === void 0 ? void 0 : link.hasBetaTag;
                break;
            default:
                href = links[linkKey];
        }
        return {
            icon: icon,
            href: href,
            openInNewTab: openInNewTab,
            hasBetaTag: hasBetaTag
        };
    };
    var linkRenderer = function(linkKey, index) {
        var link = mapLinkByType({
            linkKey: linkKey
        });
        var href = link.href, icon = link.icon, openInNewTab = link.openInNewTab, hasBetaTag = link.hasBetaTag;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "link",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                onClick: trackLinkClick,
                href: href,
                target: openInNewTab ? "_blank" : "_self",
                rel: "noreferrer",
                children: [
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: icon
                        })
                    }),
                    translate(linkKey),
                    hasBetaTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "beta-tag",
                        children: translate("header.tabs.solutions.byProduct.dev.beta")
                    })
                ]
            })
        }, index);
    };
    var linksRenderer = function() {
        return Object.keys(links).map(linkRenderer);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterCategoryComponent, {
        className: "footer-category-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "footer-category-image-and-title-warpper",
                children: [
                    hasMondayLogoTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "monday-logo-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                            src: constants_links/* MONDAY_LOGO_SRC */.Onk,
                            className: "footer-monday-logo-image",
                            href: constants_links/* ROOT_LINK */.yjY,
                            alt: "monday logo"
                        })
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: translate(title)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "links",
                children: linksRenderer()
            })
        ]
    });
};
/* harmony default export */ var footer_category_component = ((0,generic_config_context/* withGenericConfig */.P)(FooterCategoryComponent));


/***/ }),

/***/ 17619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qJ": function() { return /* binding */ StyledMobileFooterContainer; },
/* harmony export */   "tc": function() { return /* binding */ StyledFooter; },
/* harmony export */   "w2": function() { return /* binding */ StyledDesktopFooterContainer; }
/* harmony export */ });
/* harmony import */ var constants_vp_sizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(698);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12573);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(273);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77521);




var StyledDesktopFooterContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    target: "e1d0qbg50"
})("display:block;@media (max-width:1199px){display:none;}");
var StyledMobileFooterContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    target: "e1d0qbg51"
})("display:none;@media (max-width:1199px){display:block;}");
var StyledFooter = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("footer", {
    target: "e1d0qbg52"
})("width:100%;display:flex;flex-direction:column;align-items:center;overflow:hidden;color:", _styles_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"]["text-gray"] */ .Z["text-gray"], ";background-color:", _styles_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_3__.WHITE_COLOR_NAME], ";.footer-content-container{max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_0__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, "px;width:100%;padding:80px 32px 0 32px;font-size:0.8125rem;display:flex;justify-content:center;position:relative;.footer-content{display:flex;flex-direction:column;width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_0__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, 'px;.all-right-reserved-container{flex-grow:1;margin-right:120px;}.categories-container{flex-grow:1;display:flex;flex-wrap:nowrap;align-items:flex-start;.categories-colmmn-wrapper{display:flex;flex-direction:column;gap:38px;& .link{& .picture-component{& img{width:18px;height:18px;}}}}.category-container{flex:1 0 auto;margin-bottom:48px;display:flex;flex-direction:column;&:last-child{flex-grow:0;}&:not(:last-child){margin-right:16px;}}}}}&:before{display:block;content:"";height:1px;width:100%;background-color:', _styles_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, ";position:relative;}@media (max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_0__/* .MOBILE_QUERY_MAX_WIDTH */ .zD, "){.footer-content-container{padding:40px 40px 0 40px;.footer-content{flex-direction:column;padding-left:24px;.all-right-reserved-container{width:100%;}.categories-container{.category-container{width:130px;align-items:center;margin-right:12px;.footer-category-component{width:130px;}}.security-logos-container{img{width:34px !important;height:34px !important;}}}}}}&.slim-footer{.footer-content-container{padding-top:48px;.footer-content{.categories-container{.category-container{&:not(:first-child){margin-top:8px;}&:last-child{flex-grow:3;}}}}}}@media (max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_0__/* .SMALL_MOBILE_QUERY_MAX_WIDTH */ .cb, "){.footer-content-container{padding:40px 16px 0 16px;}}@media (max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_0__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */ .po, "){.footer-content-container{.footer-content{padding:0;}}}");


/***/ })

}]);